import { GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS } from '../../modules/Leads/Lead_profile/redux/constants/get_lead_profile.constants';
import { USER_PROFILE_GROUPS_READ_SUCCESS } from '../../modules/UserManagement/User_profile/redux/constants/user_profile_groups.constants';

export const transform_dataMiddleware = store => next => (action) => {
    if (action.type === GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS) {
        action.payload = {
            ...action.payload,
            ref_bike_model: action.key === 'ref_bike_brand'
                ? { name: 'None', variation: '' }
                : action.payload.ref_bike_model,
            ref_bike_variant: action.key === 'ref_bike_brand'
                ? { year: 'None' }
                : action.payload.ref_bike_variant,
        };
    }

    if (action.type === USER_PROFILE_GROUPS_READ_SUCCESS) {
        let data = [];
        action.payload.forEach(({ name, description, _id }, key) => {
            data = [...data, {
                key, title: name, description, _id,
            }];
        });
        action.payload = data;
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./src/redux/middlewares/transform_data.middleware.js